module.exports = __webpack_public_path__ + "img/white2.838da64a.svg";